import { errorIcon } from "../../icon/icons/Error.icon";
import { INoticeType } from "../interfaces/INoticeType";

export const errorNotice: INoticeType = {
    colour: "var(--colour-danger)",
    icon: errorIcon
};
